<template>
  <div class="row">
    <div class="col-20 page-title-wrapper page-title">
      {{ title }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
  .page-title-wrapper {
      box-shadow: 0px 6.93056px 27.7222px rgba(0, 0, 0, 0.05);
      border-radius: 11px;
      color: white;
      background-image: url('../assets/img/page-title-background.svg');
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      padding-top: 1.25rem;
      padding-bottom: 1.25rem;
      padding-left: 2rem !important;
      padding-right: 2rem !important;
      margin-bottom: 0.75rem;
  }
</style>
